import React from "react";
import { createUseStyles, useTheme } from "react-jss";
import DisplayText, { TextVariant } from "./DisplayText";
import SASLogo from "./icons/SASLogo";
//Helpers for building themes
// export const BackgroundType = {Welcome: "welcome", GetStarted: "getstarted", Main: "main", ThankYou: "thankyou"};
// export type BackgroundType = typeof BackgroundType[keyof typeof BackgroundType];
export var BackgroundType;
(function (BackgroundType) {
    BackgroundType[BackgroundType["Welcome"] = 0] = "Welcome";
    BackgroundType[BackgroundType["GetStarted"] = 1] = "GetStarted";
    BackgroundType[BackgroundType["Main"] = 2] = "Main";
    BackgroundType[BackgroundType["ThankYou"] = 3] = "ThankYou";
})(BackgroundType || (BackgroundType = {}));
;
//TODO:Need to figure out how to do multiple computed properties within one class
// @ts-ignore
var useStyles = createUseStyles(function (theme) {
    var _a, _b, _c, _d, _e, _f;
    var _g, _h, _j, _k, _l, _m;
    return ({
        background: (_a = {
                width: "100%",
                height: "100%",
                backgroundSize: "cover",
                backgroundRepeat: "no-repeat",
                backgroundColor: function (props) { return theme.background.backgroundColor[props.type]; }
            },
            _a[theme.breakpoints.down("md")] = {
                backgroundImage: function (props) { return theme.background.backgroundImage.small[props.type]; },
            },
            _a.backgroundImage = function (props) { return theme.background.backgroundImage.large[props.type]; },
            _a),
        sasLogo: (_b = {
                width: 80,
                marginRight: 10
            },
            _b[theme.breakpoints.down("md")] = {
                width: 60,
            },
            _b[theme.breakpoints.up("xxl")] = {
                width: 150,
                marginBottom: 20
            },
            _b),
        sasLicense: {
            color: (_h = (_g = theme.welcome.footer) === null || _g === void 0 ? void 0 : _g.color) !== null && _h !== void 0 ? _h : "white",
            "& a": {
                color: (_k = (_j = theme.welcome.footer) === null || _j === void 0 ? void 0 : _j.color) !== null && _k !== void 0 ? _k : "white",
                textDecoration: "none"
            },
        },
        sponsoredBy: (_c = {
                color: (_m = (_l = theme.welcome.footer) === null || _l === void 0 ? void 0 : _l.color) !== null && _m !== void 0 ? _m : "white",
                fontWeight: 700
            },
            _c[theme.breakpoints.up("xxl")] = {
                fontSize: 32,
                marginBottom: 20,
                marginRight: 15
            },
            _c),
        sponsorLogo: (_d = {
                width: 60,
                marginLeft: 15
            },
            _d[theme.breakpoints.down("md")] = {
                width: 40,
            },
            _d[theme.breakpoints.up("xxl")] = {
                width: 110,
                marginBottom: 20
            },
            _d),
        footerContainer: (_e = {
                position: "fixed",
                display: "flex",
                justifyContent: "space-between",
                bottom: 12,
                left: 48,
                right: 48,
                flexDirection: "row"
            },
            _e[theme.breakpoints.down("md")] = {
                flexDirection: "column-reverse",
            },
            _e),
        sasContainer: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
        },
        sponsorContainer: (_f = {
                display: "flex",
                justifyContent: "center",
                alignItems: "center"
            },
            _f[theme.breakpoints.down("md")] = {
                marginBottom: 10,
            },
            _f),
    });
});
export default function Background(_a) {
    var _b, _c, _d, _e, _f;
    var children = _a.children, type = _a.type, _g = _a.showLogo, showLogo = _g === void 0 ? true : _g, _h = _a.showLicense, showLicense = _h === void 0 ? false : _h, _j = _a.showSponsor, showSponsor = _j === void 0 ? false : _j;
    var classes = useStyles({ type: type });
    var theme = useTheme();
    return (React.createElement("div", { className: classes.background },
        React.createElement("div", { className: classes.footerContainer },
            React.createElement("div", { className: classes.sasContainer },
                showLogo && React.createElement(SASLogo, { className: classes.sasLogo, fill: (_c = (_b = theme.welcome.footer) === null || _b === void 0 ? void 0 : _b.color) !== null && _c !== void 0 ? _c : "white" }),
                showLicense && React.createElement(DisplayText, { variant: TextVariant.s12reg, className: classes.sasLicense },
                    React.createElement("a", { href: "https://www.sas.com/en_us/legal/privacy.html", target: "_blank", rel: "noreferrer", tabIndex: -1, color: "" }, "Privacy Statement"),
                    "\u00A0|\u00A0",
                    React.createElement("a", { href: "https://www.sas.com/en_us/legal/copyright.html", target: "_blank", rel: "noreferrer", tabIndex: -1 }, "Terms of Use"),
                    "\u00A0|\u00A0",
                    React.createElement("a", { href: "https://www.sas.com/en_us/legal/copyright.html", target: "_blank", rel: "noreferrer", tabIndex: -1 }, "\u00A9 2023 SAS Institute Inc. All Rights Reserved."))),
            React.createElement("div", { className: classes.sponsorContainer }, showSponsor && ((_d = theme.welcome.footer) === null || _d === void 0 ? void 0 : _d.sponsor) && (React.createElement(React.Fragment, null,
                React.createElement(DisplayText, { variant: TextVariant.s14thin, className: classes.sponsoredBy, lineHeight: 1.2 }, "Sponsored by"),
                React.createElement("img", { className: classes.sponsorLogo, src: (_f = (_e = theme.welcome.footer) === null || _e === void 0 ? void 0 : _e.sponsor) === null || _f === void 0 ? void 0 : _f.src }))))),
        children));
}
;
//# sourceMappingURL=Background.js.map